import { DocumentReference } from "firebase/firestore";
import { Moment } from "moment";

export type SituacaoVersaoTermo = "rascunho" | "publicado" | "substituido";

export default class VersaoTermo {
  public ref!: DocumentReference<VersaoTermo>;
  public numero!: number;
  public conteudo!: string;
  public hash!: string;
  public situacao!: SituacaoVersaoTermo;
  public criadoEm?: Moment;
  public publicadoEm?: Moment;

  constructor(param: Partial<VersaoTermo>) {
    Object.assign(this, param);
  }
}